import http from './http';
import config from '~/config';

const validateResetPasswordToken = async (token) => {
    const url = `${config.urls.security}/password/reset/validate/${token}`; 
    try{
        const response = await http.get(url, null, { authHeader: false });

        if (response.errored)
            throw Error(response.error);

        return { ...response };

    } catch(err){
        console.error(err);
        return null;
    }
};

const sendResetPasswordLink = async (userId) => {
    const url = `${config.urls.security}/user/${userId}/resetPassword`;
    return http.post(url);
};

const updatePassword = async (token, password) => {
    const url = `${config.urls.security}/password/reset/update/${token}`; 
    
    return http.post(url, { password }, { authHeader: false });
};

export default {
    validateResetPasswordToken,
    updatePassword,
    sendResetPasswordLink
};